import React, { Component } from 'react';

export default class StopPropagation extends Component {
    // eslint-disable-next-line class-methods-use-this
    stop(event) {
        event.stopPropagation();
    }

    render() {
        const { children, ...rest } = this.props;

        return (
            <div
                onBlur={this.stop}
                onChange={this.stop}
                onClick={this.stop}
                onContextMenu={this.stop}
                onDoubleClick={this.stop}
                onDrag={this.stop}
                onDragEnd={this.stop}
                onDragEnter={this.stop}
                onDragExit={this.stop}
                onDragLeave={this.stop}
                onDragOver={this.stop}
                onDragStart={this.stop}
                onDrop={this.stop}
                onFocus={this.stop}
                onInput={this.stop}
                onInvalid={this.stop}
                onKeyDown={this.stop}
                onKeyPress={this.stop}
                onKeyUp={this.stop}
                onMouseDown={this.stop}
                onMouseEnter={this.stop}
                onMouseLeave={this.stop}
                onMouseMove={this.stop}
                onMouseOut={this.stop}
                onMouseOver={this.stop}
                onMouseUp={this.stop}
                onSubmit={this.stop}
                onTouchEnd={this.stop}
                onTouchStart={this.stop}
                {...rest}
            >
                {children}
            </div>
        );
    }
}
